<template>
<div class="chapter">
<div class="inner_page">
<section class="spart" epub:type="division" id="spart-002"><span epub:type="pagebreak" id="page_34" title="34"><div class="spart_debut"></div><div class="dev"><figure class="fig" id="fig-004"><div class="image"><img alt="Coleridge’s rooms at Jesus College Cambridge: “I became a proverb to the University for Idleness—the time, which I should have bestowed on the academic studies, I employed in dreaming out wild schemes of impossible extrication.”" class="image" src="images/pg_34_college.jpg"/></div><figcaption class="leg"><p class="txt_courant_ssalinea">Coleridge’s rooms at Jesus College Cambridge: “I became a proverb to the University for Idleness—the time, which I should have bestowed on the academic studies, I employed in dreaming out wild schemes of impossible extrication.”</p></figcaption></figure></div></span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p1sp2.vue?58e24c4b